import { useRef, useState, useMemo, useEffect } from 'react';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Autoplay, Pagination as SwiperPagination } from 'swiper/modules';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import styles from './index.module.less';
import { Pagination } from '../pagination';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';
import { appPath } from '@web3/base-utils';
import { useFm } from '@web3/base-hooks';
import Direction from '@/assets/images/bybitsol/direction.svg';
import cls from 'classnames';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';
import { AirdropConfig } from '@/types/bbsol';

export const RewardSlidesDesktop = () => {
  const fm = useFm();
  const swiperRef = useRef<SwiperClass>();
  const [activeItem, setActiveItem] = useState({
    index: 0,
    isEnd: false,
  });

  const { solConfig } = useBbSolConfigContext();

  const handlePaginationClick = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index, 500);
    }
  };

  const swiperItemWidth = useMemo(() => {
    if (solConfig?.airdropConfig?.length > 3) {
      return '340px';
    }

    if (solConfig?.airdropConfig?.length === 3) {
      return '384px';
    }

    if (solConfig?.airdropConfig?.length === 2) {
      return '588px';
    }
    return '100%';
  }, [solConfig]);

  const handleOnClick = (item: AirdropConfig) => {
    if (item?.webUrl) {
      scTrack(Event.Web3UserClick, {
        page_name: 'StakingWeb_BBSOLhomepage_Rewards',
        button_name: 'Rewards_Eventclick',
        spmName: item?.title,
      });
      window.open(item?.webUrl, '_blank');
    }
  };

  useEffect(() => {
    if (solConfig?.airdropConfig?.length) {
      scTrack(Event.Web3PageView, {
        package_name: 'StakingWeb_BBSOLhomepage_Rewards',
      });
    }
  }, [solConfig]);

  if (!solConfig?.airdropConfig?.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <img
          src={`${appPath}/png/bybitsol/gift.png`}
          alt=""
          className={styles.gift}
        />
        {fm('bbSOLSuperStakeRewards')}
        <img
          src={`${appPath}/png/bybitsol/gift.png`}
          alt=""
          className={styles.gift}
        />
      </div>
      <Swiper
        slidesPerView={
          solConfig?.airdropConfig?.length > 3
            ? 3.3
            : solConfig?.airdropConfig?.length
        }
        spaceBetween={24}
        className={styles.slider}
        modules={[Autoplay, SwiperPagination]}
        autoplay={
          solConfig?.airdropConfig?.length > 3
            ? {
                delay: 5000,
              }
            : false
        }
        onSlideChange={(swiper) => {
          setActiveItem({
            index: swiper.realIndex,
            isEnd: swiper.isEnd,
          });
        }}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {solConfig?.airdropConfig?.map((slide, index) => {
          return (
            <SwiperSlide key={`airdrop_${index}`}>
              <div
                className={styles.slideItem}
                style={{ width: swiperItemWidth }}
                onClick={() => {
                  handleOnClick(slide);
                }}
              >
                <div className={styles.left}>
                  <img src={slide?.logoUrl ?? ''} alt="" />
                  <div
                    className={cls(
                      styles.description,
                      solConfig?.airdropConfig?.length <= 2 ? styles.less : ''
                    )}
                  >
                    {slide.title}
                  </div>
                </div>

                <Direction className={styles.direction} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {solConfig?.airdropConfig?.length > 3 ? (
        <Pagination
          controllNum={3}
          oneBarWidth={24}
          total={solConfig?.airdropConfig?.length}
          activeItem={activeItem}
          onPageChange={handlePaginationClick}
        />
      ) : null}
    </div>
  );
};
